<template>
	<div id="stationOffset">
		<confirm ref="confirm" id="confirmStationConfig" @confirm="confirmDel"></confirm>
		<div class="offset pt1x">
			<div v-show="chooseType==='offsetTotal'" class="pl2x">
				<span class="mb1x dpIB">{{getLanguageStr('plant330','累计发电量偏移量')}}(kWh):</span>
				<input-text class="w30x input mr1x" v-model="requestData.totalOffset"  
					 only="number"
					 :verification="'notEmpty,~:-99999999.99~99999999.99'"
					  @Keyup="totalAllOffset" ></input-text>
				<p class="mt2x">1.{{getLanguageStr('phrase863','偏移量将会在你每次设置完成后的30分钟内生效')}}</p>
				<p>2.{{getLanguageStr('phrase859','输入内容示例100、-100、100.03、-100.03')}}</p>
				<p>3.{{getLanguageStr('phrase860','输入完成后，累计发电量参数将加上你输入的偏移量')}}</p>
				<p>4.{{getLanguageStr('phrase861','仅累计发电量的计算方式为“通过设备上传的累计发电量数据求和计算”将生效偏移量')}}</p>
				<div class="taC">
					<button class="bdSub boxR hover-bg-highLight w9x mt3x mr2x sizeM" type="button"  @click="cancelAll">{{$t('cmd85',['取消'])}}</button>
					<button class="functionBtn save-btn w9x sizeM" type="button" @click="configAll">{{$t('cmd84',['保存'])}}</button>
				</div>
			</div>
			<div class="clearfix" v-show="chooseType==='offsetDay'">
				<div v-show="!addShow">
				<div>
					<div class="tableSys vaM_E">
						<div class="cb">
							<span class="pl2x dpIB lh13 fL pr05x mt05x">{{$t('word1871',['选择日期以搜索当天的偏移量:'])}}:</span>
							<vue-datepicker-local  v-model="serTime" ref="serDate" class="datepicker fL" :format="'YYYY/MM/DD'" :clearable='true' @input="searchKey"></vue-datepicker-local>
							<button class="functionBtn save-btn sizeM fR mr2x" type="button" @click="showAdd">{{$t('cmd10',['添加'])}}</button>
						</div>
					</div>
				 <div class="tableScope bgContent">
					<ul class="offset-list clearfix posR" fillHeight="lastHeight,-#stationOffset .tableBatch" scroll>
						<loading v-if="loadingFlag"></loading>
						<li>
							<div>{{$t('word1194',['日期'])}}</div>
							<div>{{$t('word1192',['偏移量'])}} (kWh)</div>
							<div>{{$t('word47',['操作'])}}</div>
						</li>
						<li class="taC h4x w100pct" v-show="!loadingFlag && !dayList.length">{{$t('word1380',['暂无数据'])}}</li>
						<li v-for="(item,index) in dayList" :key="index" v-show="dayList.length">
							<div :title="item.date"><span v-if="typeOf=='DAY'">{{item.date}}</span><span v-else>{{item.date.substring(0,7)}}</span></div>
							<div :title="item.valueOffset">{{item.valueOffset}}</div>
							<div><button class="bdSub hover-bg-highLight sizeS pl1x pr1x boxR" type="button" @click="deleteDayOffset(item)">{{$t('cmd9',['删除'])}}</button></div>
						</li>
			  		</ul>
			  		  <div class="tableBatch bgContent cSub" :class="{disable:!dayList}">
							<Pagination :pagination="pagination" :getList="getList" ref="Pagination"></Pagination>
						</div>
					 </div>
				</div>
				</div>
				<div v-show="addShow" class="pl2x pr3x">
					<!--<h2>
						<div v-for="(item,index) in title" :key="index" class="mr2x"  @click="change(index)">{{item}}</div><!--:class="{cMain:activeIndex==index}"
					</h2>-->
					<div class="clearfix lh15">
							<p>{{$t('word1192',['偏移量'])}} (kWh): </p>
							<vue-datepicker-local v-model="time" ref="date" class="datepicker dpIB" :format="'YYYY/MM/DD'" v-if="activeIndex==0" :disabled-date="disabledDate" style="padding-left:0 ;"></vue-datepicker-local>
							<vue-datepicker-local v-model="month" ref="month" class="datepicker dpIB" :format="'YYYY/MM'" v-if="activeIndex==1" :disabled-date="disabledDate"></vue-datepicker-local>
							<input-text class="input mt05x w60pct dpIB"
								 v-model="requestData.dayOffset" 
								 only="number"
								 :verification="'notEmpty,~:-99999999.99~99999999.99'"
								  @Keyup="dayOffset"></input-text>
							<p class="mt2x mb05x">1.{{getLanguageStr('phrase863','偏移量将会在你每次设置完成后的30分钟内生效')}}</p>
							<p class="mb05x">2.{{getLanguageStr('phrase911','输入内容示例100、-100、100.03、-100.03。仅需输入选择日期最终的偏移量，比如你想在2019/1/1加上100kWh的偏移量，仅需输入100即可，如果你觉得100偏移量不对，应该是90，仅需输入90即可。')}}</p>
							<p class="mb05x">3.{{getLanguageStr('phrase862','输入完成后，日发电量将加上你输入的偏移量，同时影响月发电量、年发电量，如果累计发电量的计算方式是通过每日发电量求和计算，那么也将受到影响。')}}</p>
					</div>
					<div class="taC">
					<button class="bdSub boxR hover-bg-highLight w6x mt3x mr2x sizeM" type="button"  @click="cancelAdd">{{$t('cmd85',['取消'])}}</button>
					<button class="functionBtn save-btn w6x sizeM" type="button" @click="addOffset">{{$t('cmd84',['保存'])}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters,mapMutations,mapActions } from 'vuex'
import * as lib from "@/util/lib"
import InputText from "@/components/common/ui/InputText"
import Select from "@/components/common/ui/Select.vue"
import Loading from '@/components/common/ui/Loading'
import NoResult from '@/components/common/ui/NoResult'
import Confirm from '@/components/common/ui/Confirm'
import Help from '@/components/common/Help'
import {timeFormat} from "@/util/lib.js";
import {getLanguageStr} from "@/util/language"
import * as configApi from '@/api/maintain/config'
import Pagination from '@/components/common/ui/Pagination.vue'
const validReg = /^-?(0|[1-9]\d{0,7})(?:|\.\d{0,2})$/
let reg = /-?\d+(\.(\d{1,2}))?/
export default {
	name: 'stationOffsetConfig',
	props: {
		req: {
			type: Object,
			default: () => ({})
		},
		total: {
			type: Number,
			default: 0
		},
		totalDay: {
			type: String,
			default: ''
		},
		loading: {
			type: Boolean,
			default: false
		},
		basicInfo:{
			type: Object,
			default: () => ({})
		},
		chooseType:{
			type: String,
			default: ''
		},
		hAddShowFlag:{
			type:Boolean,
			default:null
		},
		stationId:{
			type:Number,
			default: 0
		},
		powerType:{//能源类型light,wind
			type:String,
			default:"light"
		}
	},
	components:{
		InputText,
		Loading,
		NoResult,
		Select,
		Confirm,
		Help,
		Pagination
	},
	data(){
		return{
			addShow:false,
			pagination: {}, // 分页数据
			"orderDirection": this.orderDirection||"DESC",
			"orderProperty":this.orderProperty||"date",
	    	orderByed: this.orderBy,
	    	reqData:{},//日偏移量参数
			dayList:[],
			serTime:this.getStationDay(),
			time:this.getPrevDay(),
			month:this.getPrevMonth(),
			typeOf:"DAY",
			configBtnList: [
				{name: getLanguageStr('plant301','偏移量设置'),key:'offset'},
				{name: getLanguageStr('word1722','数据来源设置'), key:'source'}
			],
			//title:[getLanguageStr('word1981','日发电量偏移量'),getLanguageStr('cmd95+word751+word1192','月发电量偏移量')],
			title:[getLanguageStr('word1981','日发电量偏移量')],
			activeIndex:0,
            requestData: this.req,
			loadingFlag: false,
			// totalOffset: this.total,
			globalOffset:0,
			AllOffset: 0,
			errMsg:{
				allOffset:{
					msg: '',
					show: false,
					msgs:[getLanguageStr('plant300','偏移量不能为空'),i18n.t('fill3rd113',['-99999999.99-99999999.99','请输入-99999999.99-99999999.99之间的数字(保留两位)'])]
				},
				dayOffset:{
					msg: '',
					show: false,
					msgs:[getLanguageStr('plant300','偏移量不能为空'),i18n.t('fill3rd113',['-99999999.99-99999999.99','请输入-99999999.99-99999999.99之间的数字(保留两位)'])]
				}
			},
			repeatData:{},//数据来源设置
		}
	},
	methods:{
		...mapMutations({
			SET_CONFIG: 'stationConfig/SET_CONFIG',
			SET_LEVEL: 'stationConfig/SET_LEVEL'
		}),
		getLanguageStr,
		showAdd(){
			this.addShow=true;
			this.requestData.dayOffset=''
			this.serTime='';//清空查询的值
			this.searchKey();
			this.$emit('addShowCalc',true);
		},
		cancelAdd(){
			this.$emit('addShowCalc',false);
			this.$nextTick(()=>{
				this.addShow=false;
			})
		},
		getList(data){
			this.loadingFlag=true;
			if (data) this.$set(this.pagination.request, 'page', 1)
			let params={
				'type':'DAY',
				'order.direction':this.orderDirection,
				'order.property':this.orderProperty,
				'size':this.pagination.request.size,
				'page':this.pagination.request.page
			}
		    configApi.getOffsetList(this.stationId,params,this.reqData).then(res => {
		    	this.dayList=res.data;
	       		let {total} = res
				this.pagination = {...this.pagination, ...{total}}
		    	this.$nextTick(function () {
		          	lib.fillHeight()
					this.loadingFlag=false;
				})
		     }, error => {
		        !_.isEmpty(error) && this.$notify(error)
		        this.loadingFlag=false;
		    });
		},
		reset(){
			this.activeIndex=0;
			this.typeOf='DAY'
			this.serTime='';
			this.time=this.getPrevDay();
			this.month=this.getPrevMonth()
		},
		disabledDateSer(time){
			let day=time.getTime();
			return day >new Date(timeFormat(new Date(),"utc","%Y/%m/%d",{offset: this.basicInfo.region.timezone})).getTime()- (24 * 60 * 60 * 1000)
		},
		disabledDate (time) {
			let day=time.getTime();
			if(this.activeIndex==0){
				return day > this.getPrevDay().getTime()
				//  day> new Date().getTime()-24*60*60*1000
				//  day < minPrevDay || 
				// 
			}else{
				return day > this.getPrevMonth().getTime() 
				// || day < minPrevDay 
			}
		},
		getAll(id){
			this.AllOffset=0
			configApi.configAll(id).then(res=>{
			    this.requestData.totalOffset=Number(res.globalOffset)
				this.AllOffset=Number(res.dayMonthOffsetTotal)
			},error=>{
				!_.isEmpty(error) && this.$notify(error)
			})
		},
		clear(){
			for(let key in this.errMsg){
				for(let attr in this.errMsg[key]){
					if(attr === 'show'){
						this.errMsg[key][attr] = false
					}
				}
			}
		},
		totalAllOffset() {
			let {totalOffset} = this.requestData
			let {allOffset} = this.errMsg
			this.verify(totalOffset, allOffset)
		},
		totalAllOffsetBlur() {
			let {totalOffset} = this.requestData
			if(totalOffset){
				this.requestData.totalOffset = totalOffset.match(reg)[0]
			}
			let {allOffset} = this.errMsg
			this.verify(this.requestData.totalOffset, allOffset)
		},
		dayOffset(){
			let {dayOffset} = this.requestData
			let {dayOffset:set} = this.errMsg
			this.verify(dayOffset, set)
		},
		dayOffsetBlur(){
			let {dayOffset} = this.requestData
			if(dayOffset){
				this.requestData.dayOffset = dayOffset.match(reg)[0]
			}
			let {dayOffset:set} = this.errMsg
			this.verify(this.requestData.dayOffset, set)
		},
		verify(offset,obj) {
			if(offset){
				if(!validReg.test(offset)) {
					obj.show = true
					obj.msg = obj.msgs[1]
					return false
				}else {
					obj.show = false
					obj.msg = ''
					return true
				}
			}else{
				obj.show = true
				obj.msg = obj.msgs[0]
				return false
			}
		},
		// 实时改变日发电偏移总量
		getTotalData(data) {
			return data.reduce((prev, next) => {
				return prev + next.valueOffset
			},0)
		},
		searchKey () {
	        this.$set(this.pagination.request, 'page', 1)
	        if(this.serTime!=""){
	        	this.reqData = {
					'day':this.serTime.getDate(),
					'month':this.serTime.getMonth()+1,
					'year':this.serTime.getFullYear()
				}
	        }else{
	        	this.reqData = {}
	        }
			this.getList()
    	},
		addOffset() {
			let {dayOffset} = this.requestData
			let {dayOffset:set} = this.errMsg
			let flag = this.verify(dayOffset, set)
			let day,month,year
			if(this.activeIndex==0){
				day=Number(this.$refs.date.text.split('/')[2])
				month=Number(this.$refs.date.text.split('/')[1])
				year=Number(this.$refs.date.text.split('/')[0])
				this.typeOf='DAY'
			}else{
				day=null
				month=Number(this.$refs.month.text.split('/')[1])
				year=Number(this.$refs.month.text.split('/')[0])
				// date=this.$refs.month.text.replace(/\//g, '-')
				this.typeOf='MONTH'
			}
			if(!flag) return
			let req = {
					day,
					month,
					year,
					type:this.typeOf,
					offset: dayOffset
			}
			configApi.addGenerationOffsetDay(this.stationId,req).then( (response) => {
				this.getList();
				this.addShow=false;
			}).catch(error => {
                !_.isEmpty(error) && this.$notify(error)
            })
		},
		deleteDayOffset(item) {
			let deleteDate=''
			if(item.periodicType=='MONTH'){
				deleteDate=item.date.substring(0,7)
			}else{
				deleteDate=item.date
			}
			let req={
				date:deleteDate,
				periodicType:item.periodicType,
				id:item.id
			}
			this.$refs.confirm.show({
		        text:getLanguageStr('phrase712','确认要删除该偏移量吗？'),
		        obj:req
	        })
		},
		confirmDel (params) {
	      let {obj} = params
	      configApi.delGenerationOffsetDay(this.stationId, obj.id).then(() => {
	      	this.getList();
	      }).catch(error => {
	        !_.isEmpty(error) && this.$notify(error)
	      })
		},
		getStationDay(){
			let day1=new Date(timeFormat(new Date(),"utc","%Y/%m/%d",{offset: this.basicInfo.region.timezone}))
			let s1 = day1.getFullYear()+"-" + (day1.getMonth()+1) + "-" + day1.getDate()
			return new Date(s1)
		},
		getPrevDay() { // 获取前一天
			let day1=new Date(timeFormat(new Date(),"utc","%Y/%m/%d",{offset: this.basicInfo.region.timezone}))
			day1.setTime(day1.getTime()-24*60*60*1000)
			let s1 = day1.getFullYear()+"-" + (day1.getMonth()+1) + "-" + day1.getDate()
			return new Date(s1)
		},
		// fn(val){
		// 	val<10?'0'+val:'' +val
		// },
		// 获取前一月
		getPrevMonth(){
			let day1 = new Date()
			let monthNum=day1.getMonth()
			if(monthNum<10){
				monthNum ='0'+ monthNum
			}
			let month=day1.getFullYear()+'-'+monthNum+'-'+'01'
			// return month
			return new Date(month)
		},
		configAll() {
			let {totalOffset} = this.requestData
			let {allOffset} = this.errMsg
			let flag = this.verify(totalOffset,allOffset)
			if(!flag) return
			let req = {
				offset: totalOffset
			}
			configApi.configTotal(this.stationId, req).then((res) => {
				this.$emit('configAll',Number(totalOffset),'set')
            }).catch(error => {
                !_.isEmpty(error) && this.$notify(error)
            })
		},
		cancelAll(){
		 	this.$emit('configAll',Number(this.requestData.totalOffset),'cancel')
		},
		change(index){
			this.activeIndex=index;
			if(index==0){
				this.typeOf='DAY'
			}else{
				this.typeOf='MONTH'
			}
			this.$emit('addOffset',this.typeOf)
		}
	},
	mounted(){
	},
	computed:{
		...mapGetters({
			config: 'stationConfig/config',
			level: 'stationConfig/level'
		}),
		totalOffset(){
			return this.total
		}
	}
}

</script>
<style lang="scss" scoped>
.offset {
	h2{font-weight: normal;}
	.datepicker{
		width:14em;
		height:2.5em;
		line-height: 2.5em;
	}
	.day-l{
		width:15em;
		float: left;
	}
	.day-r{
		margin-left:2em;
		width:35em;
		float:left;
	}
}
.offset-list {
	width:100%;border-top:1px solid rgba(0, 0, 0, 0.1);
	margin-top:2em;
	li{
		height:5em; line-height:5em;border-bottom:1px solid rgba(0, 0, 0, 0.1);
		>div {
			width: 33.33%;
			float: left;
			padding-left: 2em;
			.del-wrap{
				height:3em;line-height:3em;
				& + p{
					line-height: 1em;margin-bottom:0;height:1em;
				}
			}
		}
		&:nth-of-type(1){
			height:3em; line-height:3em;background: #f5f8fa;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/StationOffsetConfig.vue